module.exports = __webpack_public_path__ + "f3d13f4dfa479a5765649803cdf33dfb.fbx";